import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemeService } from './theme.service';

@Component({
    selector: 'app-climate-toggle',
    standalone: true,
    imports: [MatButtonModule, MatIconModule, MatTooltipModule],
    template: `
    <button mat-icon-button (click)="toggle()" 
            [matTooltip]="(themeService.isDark() ? 'Activar modo claro' : 'Activar modo oscuro')">
      <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
  `
})
export class ClimateToggleComponent {
    readonly themeService = inject(ThemeService);

    toggle() {
        this.themeService.toggleClimate();
    }
}
